import { createStyles, makeStyles } from '@material-ui/core/styles';
import { DARK_GRAY, PRIMARY, SECONDARY } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    footerRoot: {
      margin: theme.spacing(10, 0),
      paddingTop: theme.spacing(7.5),
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(3)
      }
    },
    footerSummaryRoot: {
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(3)
      }
    },
    content: {
      padding: theme.spacing(0, 3)
    },
    links: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(5),
      '& a': {
        marginBottom: theme.spacing(2),
        fontSize: '1rem',
        color: SECONDARY
      },
      '& a:hover': {
        color: PRIMARY
      }
    },
    link: {
      color: SECONDARY,
      fontSize: '1rem',
      fontFamily: 'inherit',
      letterSpacing: '.01071em',
      textDecoration: 'underline',
      cursor: 'pointer',
      fontWeight: 400,
      padding: 0,
      backgroundColor: '#00000000',
      border: 'none',
      textAlign: 'left',
      '&:hover': {
        color: PRIMARY
      }
    },
    column: {
      display: 'flex',
      flexDirection: 'column'
    },
    title: {
      marginBottom: theme.spacing(2),
      color: DARK_GRAY
    },
    language: {
      marginRight: theme.spacing(2)
    }
  });
});